module.exports = __webpack_public_path__ + "img/63.5d36a721.jpg";